import { FaChevronDown } from 'react-icons/fa';
import { displayAddress } from 'utils/address';
import { getStateName } from 'utils/states';

const capitalizeState = (state = 'california') => {
  return state?.charAt(0)?.toUpperCase() + state.slice(1);
};

export default function BusinessInfo({ formik }) {
  return (
    <div className="flex flex-col gap-[1rem]">
      <div className="mb-[0.25rem] text-[1rem] font-semibold text-[#191919]">Account Owner</div>

      <div className="flex flex-col gap-[1rem] md:flex-row">
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">First Name</label>
          <input
            type="text"
            value={formik.values.firstName}
            disabled
            className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
          />
        </div>
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Last Name</label>
          <input
            type="text"
            value={formik.values.lastName}
            disabled
            className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
          />
        </div>
      </div>

      <div className="flex flex-col gap-[1rem] md:flex-row">
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Email</label>
          <input
            type="email"
            value={formik.values.email}
            disabled
            className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
          />
        </div>
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Phone</label>
          <input
            type="tel"
            value={formik.values.phone}
            disabled
            className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
          />
        </div>
      </div>

      <div className="w-full">
        <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Address</label>
        <input
          type="text"
          value={displayAddress(formik.values.userPersonalAddress)}
          disabled
          className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
        />
      </div>

      <div className="mb-[0.25rem] mt-[0.5rem] text-[1rem] font-semibold text-[#191919]">Company Details</div>

      <div className="flex flex-col gap-[1rem] md:flex-row">
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Enter Your Business Name</label>
          <input
            type="text"
            value={formik.values.businessName}
            disabled
            className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
          />
        </div>
        <div className="w-full">
          <label className="mb-[0.25rem] block text-[0.875rem] text-[#191919]">Select State</label>
          <div className="relative">
            <input
              type="text"
              value={capitalizeState(getStateName(formik.values.state))}
              disabled
              className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] text-[1rem] text-[#191919]"
            />
            <FaChevronDown className="absolute right-2 top-4" />
          </div>
        </div>
      </div>
    </div>
  );
}
